import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { patchPlan } from "../../store/plans/actions";
export var usePlansPatch = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePatchPlans: (_a = state.Plans.responsePatchPlans) === null || _a === void 0 ? void 0 : _a.data,
            errorPatchPlans: state.Plans.errorPatchPlans,
            loadingPatchPlans: state.Plans.loadingPatchPlans,
        });
    }), responsePatchPlans = _a.responsePatchPlans, errorPatchPlans = _a.errorPatchPlans, loadingPatchPlans = _a.loadingPatchPlans;
    useEffect(function () {
        if (trigger) {
            dispatch(patchPlan({ bodyRequest: bodyRequest }));
        }
    }, [bodyRequest, trigger]);
    return {
        responsePatchPlans: responsePatchPlans,
        errorPatchPlans: errorPatchPlans,
        loadingPatchPlans: loadingPatchPlans,
    };
};
